module.exports = __webpack_public_path__ + "img/chadle_adv_04.4853d823.png";